module.exports = __webpack_public_path__ + "static/media/Logo_naturgy.217655ca.png";